module.exports = __webpack_public_path__ + "img/chair.89edfeb6.jpeg";